/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import classNames from 'classnames';
import Button from 'components/base/Button';
import Icon from 'components/icon';
import React, { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import QuickPaymentView from 'views/payment/quick-payment/QuickPaymentView';

const numberDetail = ['vehicle_number', 'challan_no', 'po_number', 'do_number'];
const driverDetail = ['driver_name', 'driver_mobile', 'challan_date'];
const locationDetail = ['location_from', 'location_to'];
const otherDetail = [
  'material',
  'gross_weight',
  'tare_weight',
  'net_weight',
  'actual_qty'
];

const CustomInput = styled(Form.Control)(({ status, accuracy }) => {
  return {
    // borderColor: status ? 'var(--phoenix-primary)' : 'transparent',
    fontSize: '0.9rem',
    paddingLeft: '8px',
    paddingRight: '8px',
    fontWeight: '300'
    // borderColor: status
    //   ? 'var(--phoenix-primary)'
    //   : accuracy > 98
    //   ? 'var(--phoenix-success)'
    //   : 'var(--phoenix-danger)',
    // '&:disabled': {
    //   color: 'var(--phoenix-dark)',
    //   // borderColor: 'rgba(var(--phoenix-gray-100-rgb), 0.7)'
    //   borderColor:
    //     accuracy > 98 ? 'var(--phoenix-success  )' : 'var(--phoenix-danger)'
    // }
  };
});
const EditBtnContainer = styled('div')(({ status, accuracy }) => {
  return {
    display: 'flex',
    marginLeft: '-1px',
    boxSizing: 'border-box',
    transition:
      'color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
    alignItems: 'center',
    backgroundColor: status
      ? 'transparent'
      : 'rgba(var(--phoenix-gray-100-rgb), 0.7)',
    border: '1px solid var(--phoenix-primary)',
    // borderColor: status ? 'var(--phoenix-primary)' : 'transparent',
    borderColor: status
      ? 'var(--phoenix-primary)'
      : accuracy > 98
        ? 'var(--phoenix-success)'
        : 'var(--phoenix-danger)',
    borderLeft: 'none',
    borderTopRightRadius: '0.375rem',
    borderBottomRightRadius: '0.375rem',
    '& .btn-small': {
      backgroundColor: 'transparent'
    }
  };
});

const ChallanField = ({ challanData, label, className }) => {
  const [fieldStatus, setFieldStatus] = useState('');
  const [editOpen, setEditOpen] = useState(false);

  const handleEdit = () => {
    setEditOpen(!editOpen);
  };

  const handleClickToggle = status => {
    setFieldStatus(status);
  };
  return (
    <div className={classNames(className)}>
      <div className="d-flex align-items-center">
        <p className="mb-0 fs-9  text-600">{label || '[Label]'}</p>
        {/* <h6 className=" text-700 mb-0">{challanData?.label}</h6> */}
      </div>
      <div className="d-flex justify-content-between gap-2">
        <div className="d-flex w-100">
          <Form.Group className="w-100">
            <CustomInput
              disabled={!editOpen}
              status={editOpen}
              // className="w-100"
              type="text"
              value={challanData}
            />
          </Form.Group>
        </div>
      </div>
      {/* <p className="lh-sm mb-0 text-1100">{challanData?.value}</p> */}
    </div>
  );
};

const FlyAshChallanGridView = ({ challan = {}, paymentCallback, refresh }) => {
  const staticPaymentData = {
    vehicleno: 'OD23AA0001',
    challan_no: 'C2024/04/344'
  };
  return (
    <Row>
      <Col md={6} className="mb-2 ps-0 pe-0">
        <div className="border border-1 p-2 rounded-2 mb-2 card">
          <Row className="mb-2">
            <Col className="mt-2" sm={4}>
              <ChallanField
                challanData={challan['gatepass_number']}
                label="Gate Pass No."
              />
            </Col>
            <Col className="mt-2" sm={4}>
              <ChallanField
                challanData={challan['vehicle_number']}
                label="Vehicle Number"
              />
            </Col>
            <Col className="mt-2" sm={4}>
              <ChallanField
                challanData={challan['challan_no']}
                label="Challan No."
              />
            </Col>
          </Row>
          {/* {otherDetail?.map(key => {
            const currentField = challan[key];
            return (
            );
          })} */}
        </div>
        <div className="border border-1 p-2 rounded-2 mb-2 card">
          <Row className="mb-2">
            <Col className="mt-2" sm={12}>
              <ChallanField
                challanData={challan['trans_by']}
                label="Transporter"
              />
            </Col>
            <Col className="mt-2" sm={12}>
              <ChallanField
                challanData={challan['driver_name']}
                label="Driver Name"
              />
            </Col>
          </Row>
          {/* {locationDetail?.map(key => {
            const currentField = challan[key];
            return (
              <div key={`challan-${key}`} className="mb-2">
                <ChallanField challanData={currentField} label=""/>
              </div>
            );
          })} */}
        </div>
        <div className="border border-1 p-2 rounded-2 card">
          <div className="mb-2">
            <div className="d-flex gap-2 flex-column flex-md-row mt-2">
              <ChallanField
                className={'w-100'}
                challanData={challan['gross_weight']}
                label="Gross Weight"
              />
              <ChallanField
                className={'w-100'}
                challanData={challan['gross_weight_date']}
                label="Gross Time"
              />
              <ChallanField
                className={'w-100'}
                challanData={challan['tare_weight']}
                label="Tare Weight"
              />
            </div>
            <div className="d-flex gap-2 flex-column flex-md-row mt-2">
              <ChallanField
                className={'w-100'}
                challanData={challan['tare_weight_date']}
                label="Tare Time"
              />
              <ChallanField
                className={'w-100'}
                challanData={challan['net_weight']}
                label="Net Weight"
              />
              <ChallanField
                className={'w-100'}
                challanData={challan['vehicle_exit_date']}
                label="Exit Time"
              />
            </div>
          </div>
          {/* {otherDetail?.map(key => {
            const currentField = challan[key];
            return (
            );
          })} */}
        </div>
      </Col>
      <Col md={6} className="ps-0 pe-0">
        <div className="mb-2">
          <QuickPaymentView
            hideNumber={true}
            payURL="challan_payment/create_payment"
            transFor="Fly Ash"
            paymentCallback={paymentCallback}
            defaultData={challan}
            minWidth="100%"
            refreshData={refresh}
            // payURL="challan_payment/create_payment"
          />
        </div>
      </Col>
    </Row>
  );
};

export default FlyAshChallanGridView;
